/*
 * @Description:
 * @Author: -898-
 * @Date: 2024-04-23 09:02:35
 * @LastEditTime: 2024-09-20 14:30:21
 * @LastEditors: qianzhen 1994344808@qq.com
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { title: '首页' }
      },
      {
        path: 'ProcurementInfo',
        component: () => import('@/views/ProcurementInfo'),
        name: 'ProcurementInfo',
        meta: { title: '招采信息' }
      },
      {
        path: 'ProcurementInfoDetail',
        component: () => import('@/views/ProcurementInfo/detail'),
        name: 'ProcurementInfoDetail',
        meta: { title: '招采信息详情' }
      },

      {
        path: 'ProcurementNotice',
        component: () => import('@/views/ProcurementNotice'),
        name: 'ProcurementNotice',
        meta: { title: '采购公告' }
      },
      {
        path: 'ProcurementNoticeDetail',
        component: () => import('@/views/ProcurementNotice/detail'),
        name: 'ProcurementNoticeDetail',
        meta: { title: '采购公告详情' }
      },

      {
        path: 'BidWinningNotice',
        component: () => import('@/views/BidWinningNotice'),
        name: 'BidWinningNotice',
        meta: { title: '中标公告' }
      },
      {
        path: 'BidWinningNoticeDetail',
        component: () => import('@/views/BidWinningNotice/detail'),
        name: 'BidWinningNoticeDetail',
        meta: { title: '中标公告详情' }
      },


      {
        path: 'IndustryConsultation',
        component: () => import('@/views/IndustryConsultation'),
        name: 'IndustryConsultation',
        meta: { title: '行业咨讯' }
      },
      {
        path: 'IndustryConsultationDetail',
        component: () => import('@/views/IndustryConsultation/detail'),
        name: 'IndustryConsultationDetail',
        meta: { title: '行业咨讯详情' }
      },

      {
        path: 'NotificationAnnouncement',
        component: () => import('@/views/NotificationAnnouncement'),
        name: 'NotificationAnnouncement',
        meta: { title: '通知公告' }
      },
      {
        path: 'NotificationAnnouncementDetail',
        component: () => import('@/views/NotificationAnnouncement/detail'),
        name: 'NotificationAnnouncementDetail',
        meta: { title: '通知公告详情' }
      },

      {
        path: 'PolicyRegulation',
        component: () => import('@/views/PolicyRegulation'),
        name: 'PolicyRegulation',
        meta: { title: '政策法规' }
      },
      {
        path: 'PolicyRegulationDetail',
        component: () => import('@/views/PolicyRegulation/detail'),
        name: 'PolicyRegulationDetail',
        meta: { title: '政策法规详情' }
      },

      {
        path: 'InquiryNotices',
        component: () => import('@/views/inquiryNotices'),
        name: 'InquiryNotices',
        meta: { title: '询价公告' }
      },
      {
        path: 'ProcureNotices',
        component: () => import('@/views/procureNotices'),
        name: 'ProcureNotices',
        meta: { title: '采购公告' },
      },
      {
        path: 'BidNotices',
        component: () => import('@/views/bidNotices'),
        name: 'BidNotices',
        meta: { title: '成交公告' }
      },
      {
        path: 'InquiryNoticesDetails',
        component: () => import('@/views/inquiryNoticesDetails'),
        name: 'InquiryNoticesDetails',
        meta: { title: '询价公告详情' }
      },
      {
        path: 'ProcureNoticesDetails',
        component: () => import('@/views/procureNoticesDetails'),
        name: 'ProcureNoticesDetail',
        meta: { title: '采购公告详情' }
      },
      {
        path: 'bidNoticesDetails',
        component: () => import('@/views/bidNoticesDetails'),
        name: 'BidNoticesDetails',
        meta: { title: '成交公告详情' }
      },
      {
        path: 'OtherNotices',
        component: () => import('@/views/otherNotices'),
        name: 'OtherNotices',
        meta: { title: '其它公告' }
      },
      {
        path: 'OtherNoticesDetails',
        component: () => import('@/views/otherNoticesDetails'),
        name: 'OtherNoticesDetails',
        meta: { title: '其它公告详情' }
      }

    ]
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
  },
  {
    path: '*',
    redirect: '/404',
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
